module.exports = __webpack_public_path__ + "img/alert-warning.0f56ab9c.svg";